import { __makeTemplateObject } from "tslib";
import styled from "styled-components";
export var ErrorMessage = styled.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: #ff4d4d;\n  font-size: 0.9rem;\n  margin: 10px 0;\n  font-weight: 500;\n"], ["\n  color: #ff4d4d;\n  font-size: 0.9rem;\n  margin: 10px 0;\n  font-weight: 500;\n"])));
var templateObject_1;
